<template>
    <section class="view">
        <div class="view-title">
            Обращение к студентам, родителям и ППС
            о переходе на дистанционное обучение
        </div>
        <div class="videos">
            <div class="video-container">
                <div class="video">
                    <iframe id="youtubeiframe_1_171878238" width="100%" height="315" src="//www.youtube.com/embed/Sm_TjrZr17g?rel=0&amp;fmt=18&amp;html5=1&amp;showinfo=0" frameborder="0" allowfullscreen="" style="height: 315px;"></iframe>
                </div>
                <div class="description">
                    Министр образования Московской области о переходе на дистанционное обучение
                </div>
            </div>

            <div class="video-container">
                <div class="video">
                    <iframe id="youtubeiframe_2_171878238" width="100%" height="315" src="//www.youtube.com/embed/7CxNXfXckEI?rel=0&amp;fmt=18&amp;html5=1&amp;showinfo=0" frameborder="0" allowfullscreen="" style="height: 315px;"></iframe>            </div>
                <div class="description">
                    Что делается для того, чтобы не допустить распространения коронавирусной инфекции и как для студентов будет организован учебный процесс
                </div>
            </div>

        </div>
    </section>
</template>

<script>
    export default {
        name: "Appeal"
    }
</script>

<style scoped>
    .view-title{
        font-size: 40px;
        color: #18224b;
        line-height: 1.23;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 600;
        padding: 20px 0 60px 0;
        text-align: center;
    }

    .videos{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: baseline;
    }

    .video-container{
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 560px;
        display: flex;
        flex-direction: column;

        margin: 0 25px;
    }

    .video {
        width: 100%;

    }

    .video-container .description{
        text-align: left;
        padding-top: 20px;
        font-size: 20px;
        line-height: 1.55;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 400;
        color: #000;
    }

    @media (max-width: 1211px){
        .videos{
            flex-direction: column;
            align-items: center;
        }

        .video-container{
            margin: 20px 20px;
        }
    }
</style>